"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormErrorMessage_styles_1 = __importDefault(require("./FormErrorMessage.styles"));
var FormErrorMessage = function (_a) {
    var children = _a.children;
    return children ? (react_1.default.createElement(FormErrorMessage_styles_1.default, null, children)) : null;
};
exports.default = FormErrorMessage;
